<template lang='pug'>
.navbar
  .navbar-left
    i.navbar-menu.show--smallScreens
    h1.navbar-logo(@click="$router.push({'path': '/'})") LINE FACT CHECKER
  .navbar-right
    NavbarSearchDesktop(v-if="identity != 'partners' && identity != 'government'" :userProfile="userProfile" :navbarSearchText="navbarSearchText")
    NavbarSearchMobile(v-if="identity != 'partners' && identity != 'government'" :userProfile="userProfile" :navbarSearchText="navbarSearchText")
    .navbar-user.show--bigScreens(v-if="token")
      .navbar-avatar
        .navbar-holderAvatar
          .navbar-imageAvatar(v-if="userProfile.pictureUrl" :style='"background-image: url(" + userProfile.pictureUrl + ")"')
          .navbar-imageAvatar(v-else :style="defaultImage")
      .navbar-userName(v-if="userProfile.displayName") {{ userProfile.displayName }}
      .navbar-userName(v-else) test
    .navbar-action.navbar-logout.show--bigScreens(@click='login' v-if='!token') {{ loginStatus.login }}
    .navbar-action.show--bigScreens(@click='logout' v-else) {{ loginStatus.logout }}
</template>

<script>
import { login, logout } from "@/plugins/login.js"
import NavbarSearchDesktop from '@/components/nav/navbar_search_desktop.vue'
import NavbarSearchMobile from '@/components/nav/navbar_search_mobile.vue'

export default {
  components: {
    NavbarSearchDesktop,
    NavbarSearchMobile
  },
  props: {
    token: String,
    userProfile: Object,
    loginStatus: Object
  },
  data() {
    return {
      searchKeyword: "",
      searchActive: false,
      navbarSearchText: ["致癌", "新法規", "中毒"],
      identity: localStorage.getItem(this.$store.state.storageKeys.identity)
    }
  },
  computed: {
    defaultImage() {
      return "background-image: url('" + process.env.VUE_APP_CDN_URL + "/upload/avatar-empty-80-x-80%403x.png');";
    }
  },
  mounted() {
    const getHamburgerMenu = document.querySelector('.navbar-menu')
    const getSidemenu = document.querySelector('.sidemenu')
    getHamburgerMenu.addEventListener('click', () => {
      getSidemenu.classList.add('sidemenu--active')
    })
  },
  methods: {
    login() {
      login(this.$store.state)
    },
    logout() {
      logout(this.$store.state)
    },
    search() {
      this.$router.push({
        "path": "/category",
        "query": {
          "type": "searchArticles",
          "keyword": this.searchKeyword
        }
      })
    }
  }
}
</script>
